import { createContext } from 'react';
/**
 * Context for table settings.
 *
 * @type {React.Context<TableSettingsContextT>}
 *
 * @example
 * import { useContext } from 'react';
 * import { TableSettingsContext } from './table-settings-context';
 *
 * function MyComponent() {
 *   const tableSettings = useContext(TableSettingsContext);
 *   // use tableSettings.checkboxType here
 * }
 *
 * @default
 * {
 *   checkboxType: 'normal'
 * }
 */
export const TableSettingsContext = createContext({
    checkboxType: 'normal'
});
